module.exports = __webpack_public_path__ + "static/media/sns_instagram.a6f38513.png";